import React, { useEffect } from 'react'
import { callNativeByParams, getUA } from '@penguin/utils'
const ua = getUA()
const LINKS = {
  card: 'https://t.vip.com/tnsvcuBozQ8?chanTag=aae90fd0bb0f7946cf9a1097fae2e565',
  zero: 'https://h5user.qiekj.com/integral/VipShop'
}

const VipLand = () => {
  useEffect(() => {
    document.title = '胖乖X唯品会开学福利来啦'
  }, [])
  return (
    <div>
      <div className='absolute top-0 left-0 w-full' style={{ fontSize: 0 }}>
        <img src='https://static.qiekj.com/static/web/image/vip-land-page-1.jpg' alt='' />
        <img src='https://static.qiekj.com/static/web/image/vip-land-page-2.jpg' alt='' />
        <img src='https://static.qiekj.com/static/web/image/vip-land-page-3.jpg' alt='' />
        <img src='https://static.qiekj.com/static/web/image/vip-land-page-4.jpg' alt='' />
      </div>
      <div className='relative flex flex-col'>
        <div
          onClick={() => {
            if (ua === 'app') {
              callNativeByParams('jumpNativePage', {
                url: LINKS.card,
              })
            } else {
              window.location.href = LINKS.card
            }
          }}
          className='rem:mt-[1170px] p-8 rem:w-[200px]'
        ></div>
        <div
          onClick={() => {
            if (ua === 'app') {
              callNativeByParams('jumpNativePage', {
                url: LINKS.zero,
              })
            } else {
              window.location.href = LINKS.zero
            }
          }}
          className='rem:mt-[1000px] p-8 pl-32 pr-32'
        ></div>
      </div>
    </div>
  )
}

export default VipLand
